import React from 'react';
import { Image } from 'react-konva';
import useImage from 'use-image';

/*
 * A component to present the picture from the react-konva docs
 */
const Picture = ({ initialScale, imageURL }) => {
    const [image] = useImage(imageURL);
    const width = image?.width ?? 0;
    const height = image?.height ?? 0;

    return (
        <Image
            image={image}
            width={width}
            height={height}
            offsetX={width / 2}
            offsetY={height / 2}
            scaleX={initialScale}
            scaleY={initialScale}
            style={{ cursor: 'grab' }}
        />
    );
};

export default Picture;
